import script from "./ManutOsOrcamentoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ManutOsOrcamentoPage.vue?vue&type=script&setup=true&lang=js"

import "./ManutOsOrcamentoPage.vue?vue&type=style&index=0&id=3735e3cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3735e3cc"]])

export default __exports__